/**
 * @Author: 左建
 * @Date: 2022/6/14 15:13
 * @LastEditTime: 2022/6/14 15:13
 * @Description: 首页迭代接口
**/
import { get, post } from "@/utils/request"
import { HOME_PAGE_MAP } from "@/utils/platform-config";
import store from "@/store";
/**
 * 获取导航栏菜单
 * @return {Promise<any>}
 **/
export function getNavMenu () {
    const PlatformName = HOME_PAGE_MAP[store.state.platform].domain
    return post("/Manage/Platform/GetSystemHander", { PlatformName })
}
